export async function http (method, url, params = {}, isAuthorized = false) {
  method = method.toLowerCase()
  if (isAuthorized) {
    const { getFromStorage } = useStorage()

    params.headers = {
      ...params.headers,
      Authorization: `Bearer ${getFromStorage(storageKeys.authToken)}`
    }
  }

  const options = { method, ...params }

  try {
    const response = await $fetch(url, options)
    return response
  } catch (error) {
    const status = error?.status || error?.statusCode
    
    switch (status) {
      case 401:
        const router = useRouter()
        const { removeFromStorage } = useStorage()
        removeFromStorage(storageKeys.authToken)
        router.push('/')
        throw error
      default:
        if (error?.data?.message) {
          notify('error', error?.data?.message)
        }
        throw error
    }
  }
}